export default __webpack_public_path__ + "static/media/Student icon.d4d53fbb.svg";